// Data Masking Types
export type MaskType = 'email' | 'phone' | 'gstin' | 'partial' | 'custom' | '';

// User reference for createdBy/updatedBy
export interface IUserReference {
  ID: number;
  FullName: string;
  EmailID?: string;
  EmployeeCode?: string;
}

// Create Data Masking DTO
export interface ICreateDataMaskingDto {
  tableName: string;
  columnName: string;
  maskType: MaskType;
  maskChar?: string;
  maskPattern?: string;
  status?: number;
}

// Update Data Masking DTO (Partial of Create)
export type IUpdateDataMaskingDto = Partial<ICreateDataMaskingDto>;

// Data Masking Entity (Response from API)
export interface IDataMasking {
  id: number;
  tableName: string;
  columnName: string;
  maskType: MaskType;
  maskChar: string;
  maskPattern?: string | null;
  status: number;
  createdById?: number | null;
  updatedById?: number | null;
  createdAt: string;
  updatedAt: string;
  createdByUser?: IUserReference | null;
  updatedByUser?: IUserReference | null;
}

// Table columns interface for react-table
export interface IDataMaskingTableColumns extends IDataMasking {
  action?: string;
}

// Query params for GET all data masking
export interface IGetDataMaskingParams {
  page: number;
  pageSize: number;
  status?: number;
  tableName?: string;
}

// Response structure for GET all
export interface IDataMaskingListResponse {
  data: IDataMasking[];
  count: number;
  message: string;
}

// Response structure for single item
export interface IDataMaskingResponse {
  data: IDataMasking;
  message: string;
}

// Mask type options for dropdown
export const MASK_TYPE_OPTIONS = [
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone' },
  { value: 'gstin', label: 'GSTIN' },
  { value: 'partial', label: 'Partial' },
  { value: 'custom', label: 'Custom' },
];

// Default mask patterns for each mask type
export const DEFAULT_MASK_PATTERNS: Record<string, string> = {
  email: 'S{1}*@domain', // Show first 1 character of local part, mask rest, show domain
  phone: '*E{4}', // Show only last 4 digits
  gstin: 'S{2}*E{2}', // Show first 2 and last 2 characters
  partial: 'S{2}*E{2}', // Show first 2 and last 2 characters
  custom: '', // User enters their own pattern
};

// Status options for dropdown
export const STATUS_OPTIONS = [
  { value: 1, label: 'Active' },
  { value: 0, label: 'Inactive' },
];
